import { lazy } from 'react';

const LazyApiKeyEditView = lazy(() => import('./api-key-edit-view'));
export default LazyApiKeyEditView;
